var scrollToAnchorOffSet = 120;
function LocaleSet(newLanguage) {

    var curCookie = Cookies.get('Locale');
    if (curCookie != newLanguage) {
        console.log('Switching lang to : %o ', newLanguage);
        // Set the cookie
        Cookies.set('Locale', newLanguage);
    } else {
        //console.log('Skipping cookie write as already set');
    }

}
function AgeGateSet(country) {
    var date = new Date();
    var agCookie = {
        date: date.toString(),
        country: country
    }
    Cookies.set('AgeGate', JSON.stringify(agCookie), { expires: 30 });
}

function scrollToAnchor(aName) {
    var aTag = $("a[name='" + aName + "']");
    $('html,body').animate({ scrollTop: aTag.offset().top }, 'slow');
}
function scrollToAnchorID(aId) {
    var aTag = $("#" + aId);
    $('html,body').animate({ scrollTop: aTag.offset().top }, 'slow');
}

function scrollToAnchorOffset(aName) {
    var aTag = $("a[name='" + aName + "']");
    $('html,body').animate({ scrollTop: aTag.offset().top - scrollToAnchorOffSet }, 'slow');
}
function scrollToAnchorIDOffset(aId) {
    var aTag = $("#" + aId);
    $('html,body').animate({ scrollTop: aTag.offset().top - scrollToAnchorOffSet }, 'slow');
}

function isEmptyOrSpaces(str) {
    if (str === undefined) { return true; }
    return str === null || str.match(/^ *$/) !== null;
}

function nodeListToIds(list) {
    //console.log(' node list : %o', list);
    let nodeIds = [];
    if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {

            var itm = list[i];
            //console.log('%o - %o', itm, itm.checked);
            if (itm.checked) {
                nodeIds.push(itm.value);
            }
        }
    }
    //console.log('node ids : %o', nodeIds);
    return nodeIds;
}

function trapFocus(e, modalId) {
    const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

    /**
     * If a key other than tab is pressed, ignore.
     */
    if (!isTabPressed) {
        return;
    }

    /**
     * Get the targeted modal.
     */
    const modal = document.getElementById(modalId);



    /**
     * Get all focusable elements in the modal.
     */
    const focusableContent = getKeyboardFocusableElements(modal);

    const firstFocusableElement = focusableContent[0];
    const lastFocusableElement = focusableContent[focusableContent.length - 1];

    if (e.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
            /**
             * If tabbing backward (shift-tab) and we're currently on the first element, focus on the last element.
             */
            lastFocusableElement.focus();
            e.preventDefault();
        }
    } else if (document.activeElement === lastFocusableElement || (document.activeElement.name && lastFocusableElement.name && document.activeElement.name === lastFocusableElement.name)) {
        /**
         * If tabbing forward and we're currently on the last element, focus on the first element.
         */
        firstFocusableElement.focus();
        e.preventDefault();
    }
}

function LocaleSet(newLanguage) {

    var curCookie = Cookies.get('Locale');
    if (curCookie != newLanguage) {
        console.log('Switching lang to : %o ', newLanguage);
        // Set the cookie
        Cookies.set('Locale', newLanguage);
    } else {
        //console.log('Skipping cookie write as already set');
    }

}

function getKeyboardFocusableElements(element = document) {
    return [
        ...element.querySelectorAll(
            'a[href], button, input:not([type="hidden"]), textarea, select, iframe, details, [tabindex]:not([tabindex="-1"])',
        ),
    ].filter(
        el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden') && el.checkVisibility(),
    )
}